import { Text } from './RequiredText.styled'

const RequiredText = ({ isSmall = false }: { isSmall?: boolean }) => {
    return (
        <Text isSmall={isSmall}>Required</Text>
    )
}

export default RequiredText